module.exports = __webpack_public_path__ + "7db1d97bc4549a4636f30cf6b278b990.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/image/ic_history.svg
// module id = 1162
// module chunks = 0